// extracted by mini-css-extract-plugin
export default {"paper":"Descriptions_paper__72qq6","button":"Descriptions_button__rSPBg","tooltip":"Descriptions_tooltip__wqTLS"};